'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WhyClassPassV1 = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _promotions = require('constants/promotions');

var _CallToAction = require('components/CallToAction');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WhyClassPassV1 = exports.WhyClassPassV1 = function (_Component) {
  (0, _inherits3.default)(WhyClassPassV1, _Component);

  function WhyClassPassV1() {
    (0, _classCallCheck3.default)(this, WhyClassPassV1);
    return (0, _possibleConstructorReturn3.default)(this, (WhyClassPassV1.__proto__ || (0, _getPrototypeOf2.default)(WhyClassPassV1)).apply(this, arguments));
  }

  (0, _createClass3.default)(WhyClassPassV1, [{
    key: 'renderCta',
    value: function renderCta(ctaCopy, ctaUrl, ctaExtraClass, ctaColor) {
      return _react2.default.createElement(
        _CallToAction.CallToAction,
        {
          action: _CallToAction.ACTIONS.LINK,
          color: ctaColor,
          extraClass: ctaExtraClass + ' bt--lg why-classpass-v1__bt',
          to: ctaUrl
        },
        ctaCopy
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this = this;

      var title = 'Why ClassPass?';
      var cards = [{
        image: require('./static/img/card1-v1.jpg'),
        caption: 'Endless fitness possibilities',
        copy: 'Yoga, cycling, boxing, dance, strength training, whatever your thing is, it’s on ClassPass.',
        ctaCopy: 'Explore studios',
        ctaUrl: '/explore',
        ctaExtraClass: 'why-classpass-v1__bt--explore',
        ctaColor: 'primary',
        id: 1
      }, {
        image: require('./static/img/card2-v1.jpg'),
        caption: 'All in one place',
        copy: 'We make it super easy to discover and book your next favorite class at the tap of a button.',
        ctaCopy: 'Start a free trial',
        ctaUrl: '/pricing/' + _promotions.GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS,
        ctaExtraClass: 'why-classpass-v1__bt--pricing',
        ctaColor: 'primary_solid',
        id: 2
      }];

      return _react2.default.createElement(
        'section',
        { className: 'why-classpass-v1' },
        _react2.default.createElement(
          'h2',
          { className: 'why-classpass-v1__title' },
          title
        ),
        _react2.default.createElement(
          'div',
          { className: 'why-classpass-v1__content' },
          _react2.default.createElement(
            'ul',
            null,
            cards.map(function (card) {
              return _react2.default.createElement(
                'li',
                { className: 'why-classpass-v1__content__card', key: card.id },
                _react2.default.createElement('img', { src: card.image, alt: card.caption }),
                _react2.default.createElement(
                  'div',
                  { className: 'why-classpass-v1__content__card__text' },
                  _react2.default.createElement(
                    'h3',
                    { className: 'why-classpass-v1__content__card__text__caption' },
                    card.caption
                  ),
                  _react2.default.createElement(
                    'p',
                    { className: 'why-classpass-v1__content__card__text__copy' },
                    card.copy
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'why-classpass-v1__content__card__cta' },
                  _this.renderCta(card.ctaCopy, card.ctaUrl, card.ctaExtraClass, card.ctaColor)
                )
              );
            })
          )
        )
      );
    }
  }]);
  return WhyClassPassV1;
}(_react.Component);